import "./MainTreatment.css";
import img1 from '../images/post_natal.webp'
import img2 from '../images/main_reju.webp'
import img3 from '../images/main_hair.webp'
import img4 from '../images/main_life.webp'
import img5 from '../images/main_kalpa.webp'
import { Link } from "react-router-dom";
 import Aos from "aos";
  import "aos/dist/aos.css";
  import { useEffect } from "react";


export default function MainTreatment() {
 

    useEffect(() => {
    Aos.init({
      duration: 1000,      // animation duration
      easing: "ease-in-out",
      once: true,          // animation happens only once
      offset: 100,         // offset from the trigger point
    });
  
    Aos.refresh(); // optional but recommended
  }, []);
  return (
   <section className="container-fluid ayt-section py-5">
      <div className="container">

        {/* Section Heading */}
        <div className="text-center mb-5">
          <p className="ayt-subtitle">OUR TREATMENTS</p>
          <h2 className="ayt-title head-font">
           Heal Traditionally Through The Power Of Ayurveda
          </h2>
        </div>

        {/* ===== ROW 1 (3 cards) ===== */}
        <div className="row g-4 justify-content-center"  data-aos="fade-up">
          <div className="col-lg-4 col-md-6">
            <div className="ayt-card">
              <img src={img1} alt="Post Natal Care" />
              <div className="ayt-overlay">
                <h5 className="para-font">Postnatal Care</h5>
                <Link className="ayt-btn" to="/postnatal">Read More</Link>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6">
            <div className="ayt-card">
              <img src={img2} alt="Rejuvenation Therapy" />
              <div className="ayt-overlay">
                <h5 className="para-font">Rejuvenation Therapy</h5>
                <Link className="ayt-btn" to="/rejuvenation">Read More</Link>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6">
            <div className="ayt-card">
              <img src={img3} alt="Hair Treatment" />
              <div className="ayt-overlay">
                <h5 className="para-font">Hair Treatment</h5>
                <Link className="ayt-btn" to="/hair_treatment">Read More</Link>
              </div>
            </div>
          </div>
        </div>

        {/* ===== ROW 2 (2 centered cards) ===== */}
         <div className="row g-4 justify-content-center mt-4"  data-aos="fade-up">
          <div className="col-lg-4 col-md-6">
            <div className="ayt-card">
              <img src={img4} alt="Post Natal Care" />
              <div className="ayt-overlay">
                <h5 className="para-font">Life Style Guidance & Yoga</h5>
                <Link className="ayt-btn" to="/lifestyle_yoga">Read More</Link>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6">
            <div className="ayt-card">
              <img src={img5} alt="Rejuvenation Therapy" />
              <div className="ayt-overlay">
                <h5 className="para-font">Soundarya Kalpa</h5>
                <Link className="ayt-btn" to="/soundarya_kalpa">Read More</Link>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6">
           
          </div>
        </div>

      </div>
    </section>
  );
}
